import { useFormContext } from 'react-hook-form';

import { FormControl, Grid } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { MonetaryUnitsSelector } from 'components/BusinessToolForm/components/MonetaryUnitsSelector';
import { UNITS_VALUES } from 'components/BusinessToolForm/constants/options';

import { concatWithDot } from 'helpers/string';

import { VolumeSelector } from './VolumeSelector';
import { UNITS_NAMES_STRUCTURE, UnitValues } from '../../utils/form';

import styles from './UnitsPicker.module.scss';

interface IVolumePickerProps {
  name: string;
  disabled: boolean;
}

export const UnitsPicker = ({ name, disabled }: IVolumePickerProps) => {
  const { control, getValues } = useFormContext();
  const currentUnitType = getValues(concatWithDot(name, UNITS_NAMES_STRUCTURE.SELECTED_UNITS)) as UnitValues;

  const options = [
    {
      component: (
        <VolumeSelector
          name={concatWithDot(name, UNITS_NAMES_STRUCTURE.VOLUME)}
          disabled={currentUnitType === UNITS_VALUES.CURRENCY || disabled}
        />
      ),
      value: UNITS_VALUES.VOLUME_IN,
    },
    {
      component: <MonetaryUnitsSelector name={concatWithDot(name, UNITS_NAMES_STRUCTURE.CURRENCY)} />,
      value: UNITS_VALUES.CURRENCY,
    },
  ];

  return (
    <RadioControlled
      disabled={disabled}
      control={control}
      name={concatWithDot(name, UNITS_NAMES_STRUCTURE.SELECTED_UNITS)}
      radioControlledStyles={{ radioLabel: styles.radioLabel }}
      options={options.map(({ component, value }) => ({
        label: (
          <Grid container gap="10px">
            <FormControl disabled={disabled}>{component}</FormControl>
          </Grid>
        ),
        value,
      }))}
    />
  );
};
